if ($("footer#footer").length) {
  $("#signature a:first").prepend("<span>"+translation("vytvoril")+"</span>");
  $("#signature a:eq(1)").text("Shoptet");
  $("#signature").append('<span>| <a href="https://www.shopcode.cz" target="_blank" >Shopcode</a></span>');

  $(".overall-wrapper").append($("#footer .prodejna"));
  $("#footer .prodejna #map").attr("id", "mapFooter");
  $(".overall-wrapper").append($("#footer .reviews").clone());
  $(".overall-wrapper").append($("#footer .instagramFeed").clone());
  $(".instagram-widget>a").each(function () {
    $(".instagramFeed .igFeed").append('<div class="igPost"><a href="' + $(this).attr("href") + '" target="_blank" style="background-image: url(' + $(this).find("img").attr("data-src") + ')"></a></div>');
  });

  $(document).on("click", ".custom-footer > div .h4", function () {
    const parent = $(this).closest(".custom-footer > div");
    const isOpen = parent.hasClass("openIt");
    $(".custom-footer > div").removeClass("openIt");

    if (!isOpen) {
      parent.addClass("openIt");
    }
  });

  $("footer#footer .customSocials").append($("footer#footer .contact-box li span.facebook").closest("li"), $("footer#footer .contact-box li span.instagram").closest("li"));
  $("footer#footer .customSocials").append($("footer#footer .contact-box li span.instagram").closest("li"), $("footer#footer .contact-box li span.instagram").closest("li"));
  $("footer#footer .customSocials").append($("footer#footer .contact-box li span.tiktok").closest("li"), $("footer#footer .contact-box li span.instagram").closest("li"));

  $(".superContact").append($("footer#footer .contact-box li span.tel").closest("li").clone().addClass("tel"));
  $(".superContact").append($("footer#footer .contact-box li span.cellphone").closest("li").clone().addClass("cellphone"));
  $(".superContact").append($("footer#footer .contact-box li span.mail").closest("li").clone().addClass("mail"));

  $(".contacts:not(.full)").append($("footer#footer .contact-box li span.tel").closest("li").clone().addClass("tel"));
  $(".contacts:not(.full)").append($("footer#footer .contact-box li span.mail").closest("li").clone().addClass("mail"));

  $(".contacts:not(.full):not(.colc .contacts) .tel a").after("<span>"+translation('telefonInfo')+"</span>");
  $(".contacts:not(.full):not(.colc .contacts) .mail a").after("<span>" + translation('mailInfo') + "</span>");
}

if (window.innerWidth < 992) {
  $("body").addClass("customMobile");
}
